import './FormLayout.css'

function FormLayout({ title, actions, headerExtra, children, onSubmit, id }) {
    const Tag = onSubmit ? 'form' : 'div'

    return (
        <Tag className="fl-wrapper" onSubmit={onSubmit} id={id}>
            {(title || actions || headerExtra) && (
                <div className="fl-header">
                    {title && (
                        <div className="fl-title-block">
                            <p className="fl-title">{title}</p>
                            <span className="fl-title-accent" />
                        </div>
                    )}
                    {actions && (
                        <div className="fl-actions">{actions}</div>
                    )}
                    {headerExtra}
                </div>
            )}
            <div className="fl-body">
                {children}
            </div>
        </Tag>
    )
}

export default FormLayout
